//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clarityEvent } from "~/services/util";

export default {
  props: {
    data: {
      required: true,
    },
  },
  computed: {
    useLightTheme() {
      if (this.data.use_light_theme === true) return true;
      else return false;
    },
    url() {
      if (this.data.cta_url) return this.data.cta_url;
      else return "";
    },
  },
  methods: {
    registerEventAndGo(url) {
      clarityEvent("Product Page > Highlighted section");
      if (!this.data.is_external_link) this.$router.push(url);
      else window.open(url);
    },
  },
};
